import React, { PropsWithChildren, useCallback } from "react";
import useTranslations from "../../hooks/useTranslations";
import ContextBar from "../layout/ContextBar";
import Input from "../wombat-ui/Input";
import { ContractEditorState } from "./ContractEditor";
import { useContractEditorContext } from "./ContractEditorContext";

type ContractEditorVariablesFormContextBarProps = {
  contract: ContractEditorState;
};

const ContractEditorVariablesFormContextBar: React.FC<PropsWithChildren<
  ContractEditorVariablesFormContextBarProps
>> = ({ contract }) => {
  const t = useTranslations();
  const { variables, setVariables } = useContractEditorContext();

  const handleVariableChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, label: string) => {
      setVariables(label, e.target.value);
    },
    []
  );

  return (
    <ContextBar
      title={contract.title}
      description={t("contracts.context.description") as string}
    >
      <div className="px-4 divide-y divide-gray-200 sm:px-6">
        <div className="pt-6 pb-5 space-y-6">
          {variables.map((variable) => (
            <Input
              name={variable.label}
              label={variable.label}
              key={variable.label}
              onChange={(e) => handleVariableChange(e, variable.label)}
            />
          ))}
        </div>
      </div>
    </ContextBar>
  );
};

export default React.memo(ContractEditorVariablesFormContextBar);
